import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './lawyer_disclaimer.module.scss';

export const LawyerDisclaimer: FC = () => (
  <div className={styles.text}>
    <FormattedMessage id="app.pages.lawyer.disclaimer" />
  </div>
);
